// @flow

import * as React from 'react';

import type { ApplicationSummary } from '@gandi/redux-resource-simplehosting';
import { useTranslator, mapTags } from '@gandi/translate';
import { Base, Text, Hide } from '@gandi/ui';

import { useAssetPath } from 'gandi.react-asset-path';

import type { ExtendedSuggestion } from '../../DomainCreate/types';

import DomainSearch from './DomainSearch';

export type OwnProps = {
  application?: ApplicationSummary,
  handleChooseDomain: (value: ExtendedSuggestion) => mixed,
};

export type Props = {
  ...OwnProps,
};

function DomainIntro({
  application,
  handleChooseDomain,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const imagePath = useAssetPath('img/pack_domain.svg');

  return (
    <Base marginBottom="small" paddingY="base">
      <Base flex gap="small" marginBottom="base">
        <Base flexGrow1>
          <Base tagName="h2" marginBottom="small">
            {__('2. Choose your free domain')}
          </Base>
          <div>
            <Base tagName="p" margin="none">
              {mapTags(
                __(
                  'To run your [[applicationName:]], [[needADomain:]], which will be the address of your website.',
                ),
                () => ({
                  applicationName: (
                    <Text>{application?.name_label || __('web hosting')}</Text>
                  ),
                  needADomain: (
                    <Text weight="semibold">
                      {__('you need a domain name')}.
                    </Text>
                  ),
                }),
              )}
            </Base>
            <Base color="light" tagName="p" marginTop="none">
              {__(
                'Please note that you won’t be able to choose this free domain later.',
              )}
            </Base>
          </div>
        </Base>
        <Hide until="sm">
          <img alt="" height="80" src={imagePath} width="80" />
        </Hide>
      </Base>

      <DomainSearch handleChooseDomain={handleChooseDomain} />
    </Base>
  );
}

export default DomainIntro;
